<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">Administración</li>
  <li class="breadcrumb-item active">Evaluación</li>
</ol>

<h1 class="page-header"><i class="fas fa-wrench"></i> Evaluación<small> Configuración de Categorías</small></h1>

<div class="scrollable">
  <panel [noButton]="true">
    <div class="row">
      <div class="col-md-4">
        Grupo
        <ng-select [items]="groups" bindLabel="name" [(ngModel)]="selectedGroup" (ngModelChange)="getCategories()"></ng-select>
      </div>
      <div class="col-md-4">
        Año
        <ng-select [items]="years" [(ngModel)]="yearSelected" (ngModelChange)="getCategories()"></ng-select>
      </div>
    </div>
  </panel>

  <div class="row mt-5">
    <div class="col-sm-12 col-lg-4 col-xxl-3">
      <div class="nav flex-column nav-tabs border-end-0" role="tablist">
        @for(category of categories; track $index) {
        <button class="nav-link text-start d-flex justify-content-between align-items-center"
          [class.active]="selectCategoryId === category.id" (click)="selectCategory(category.id)">
          <span>{{$index + 1}} - {{category.name}}
            @if(category.tooltip){<button class="btn btn-xs btn-ghost ms-1" triggers="hover" [ngbTooltip]="category.tooltip"><i class="fas fa-circle-question"></i></button>}
          </span>
          @if(category.enabled){
          <div class="d-flex">
            @if($index < categories.length - 1) {
            <button class="btn btn-xs btn-ghost" triggers="hover" ngbTooltip="Mover abajo" (click)="moveDown($index)"><i class="fas fa-angle-down"></i></button>
            }
            @if($index > 0) {
            <button class="btn btn-xs btn-ghost" triggers="hover" ngbTooltip="Mover arriba" (click)="moveUp($index)"><i class="fas fa-angle-up"></i></button>
            }
            <button class="btn btn-xs btn-ghost" triggers="hover" ngbTooltip="Editar" (click)="editCategory(modalNewCategory, category)"><i class="fas fa-edit"></i></button>
            <button class="btn btn-xs btn-ghost" triggers="hover" ngbTooltip="Eliminar" (click)="preventRemoveCategory(category.id)"><i class="fas fa-trash"></i></button>
          </div>
          }
        </button>
        }
        @if(categories.length === 0 || !categories.every(c => !c.enabled)) {
        <button class="btn btn-sm btn-ghost mt-2" (click)="open(modalNewCategory)">+ Agregar Categoría</button>
        }
        <button class="nav-link mt-2" [class.active]="showPreview" (click)="viewPreview()" data-bs-toggle="tab">
          <i class="fas fa-eye"></i> Vista previa
        </button>
      </div>
    </div>

    <div class="col-sm-12 col-lg-8 col-xxl-9">
      <div class="tab-content border rounded bg-white p-4">
        @if(!showPreview){
          @if(categories.length > 0 && selectCategoryId){
          <app-admin-questions
            [questions]="questions"
            [selectCategoryId]="selectCategoryId"
            [yearSelected]="yearSelected"
            [questionSystem]="selectedModule"
            (reload)="getQuestions()" />
          }@else {
          <div class="text-center text-muted py-5">
            <i class="fas fa-folder-open fa-3x mb-3"></i>
            <p class="fs-5 mb-1">No hay categorías</p>
            <p class="mb-0">Seleccione un grupo y año, o agregue una nueva categoría.</p>
          </div>
          }
        }@else {
        <div>
          <span class="fs-3 fw-700">Resumen</span>
          <button class="btn btn-sm btn-outline-danger ms-3" (click)="exportPdf()" ngbTooltip="Exportar formulario a PDF">
            <i class="fas fa-file-pdf me-1"></i> Exportar PDF
          </button>
          <div class="modal-scrollable mt-5">
            <table class="table table-striped table-hover">
              @if(preview){
              <tbody>
                @for(category of preview.categories; track $index; let indexCategory = $index) {
                <tr>
                  <td class="text-nowrap fw-bold">{{indexCategory + 1}}</td>
                  <td class="fs-5 fw-bold">{{category.name}} ({{category.totalScore}})</td>
                </tr>
                @for(question of category.questions; track $index; let indexQuestion = $index) {
                <tr>
                  <td class="text-nowrap fw-bold">{{indexCategory + 1}}.{{indexQuestion + 1}}</td>
                  <td>{{question.title}}</td>
                </tr>
                @for(subquestion of question.subitems; track $index; let indexSubQuestion = $index) {
                <tr>
                  <td style="padding-left: 20px;" class="text-nowrap fw-bold">{{indexCategory + 1}}.{{indexQuestion + 1}}.{{indexSubQuestion + 1}}</td>
                  <td style="padding-left: 30px;">{{subquestion.title}}</td>
                </tr>
                }}
                }
              </tbody>
              }
            </table>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #modalNewCategory let-d="dismiss">
  <div class="modal-header">
    <span class="fs-3 fw-700">Nueva Categoría</span>
  </div>
  <div class="modal-body" [formGroup]="newCategoryForm">
    <div class="row mb-3">
      <label class="form-label col-form-label col-md-3">Nombre</label>
      <div class="col-md-7">
        <input type="text" class="form-control" formControlName="name" />
      </div>
    </div>
    <div class="row mb-3">
      <label class="form-label col-form-label col-md-3">Texto de ayuda</label>
      <div class="col-md-7">
        <textarea rows="5" class="form-control" formControlName="tooltip"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-danger" (click)="d('Cross click')">Cerrar</button>
    <button class="btn btn-primary" (click)="d('Cross click'); addCategory()">Guardar</button>
  </div>
</ng-template>
